import type { Tour } from '../tour-types';
import { platformTour } from './platform-tour';
import { homeTour } from './home-tour';
import { clientsTour } from './clients-tour';
import { healthTour } from './health-tour';
import { performanceTour } from './performance-tour';
import { programTour } from './program-tour';
import { experimentsLibraryTour } from './experiments-library-tour';
import { experimentSettingsTour } from './experiment-settings-tour';
import { experimentBriefTour } from './experiment-brief-tour';
import { experimentDebriefTour } from './experiment-debrief-tour';
import { experimentResultsTour } from './experiment-results-tour';
import { pipelinesTour, pipelineBoardTour } from './pipelines-tour';
import { FLAG_TOURS } from './flags-tour';
import { LEARNINGS_TOURS } from './learnings-tour';
import { combinationTour } from './combination-tour';
import { implementationTour } from './implementation-tour';
import { surveysLibraryTour } from './surveys-library-tour';
import { surveyBuilderTour } from './survey-builder-tour';
import { surveyOverviewTour } from './survey-overview-tour';
import { surveyResultsTour } from './survey-results-tour';
import { websitesTour } from './websites-tour';
import { googleAnalyticsTour } from './google-analytics-tour';
import { settingsGeneralTour } from './settings-general-tour';
import { settingsAccountTour } from './settings-account-tour';
import { settingsTeamTour } from './settings-team-tour';
import { settingsBillingTour } from './settings-billing-tour';
import { settingsAgentAccessTour } from './settings-agent-access-tour';

/**
 * Every tour the dashboard can run. A new screen adds its tour here. Order does not
 * decide which tour a route gets: the most specific route wins (see tourForRoute).
 */
export const TOURS: readonly Tour[] = [
  platformTour,
  homeTour,
  clientsTour,
  healthTour,
  performanceTour,
  programTour,
  experimentsLibraryTour,
  experimentSettingsTour,
  experimentBriefTour,
  experimentResultsTour,
  experimentDebriefTour,
  pipelinesTour,
  pipelineBoardTour,
  ...FLAG_TOURS,
  ...LEARNINGS_TOURS,
  combinationTour,
  implementationTour,
  surveysLibraryTour,
  surveyBuilderTour,
  surveyOverviewTour,
  surveyResultsTour,
  websitesTour,
  googleAnalyticsTour,
  settingsGeneralTour,
  settingsAccountTour,
  settingsTeamTour,
  settingsBillingTour,
  settingsAgentAccessTour,
];
